@if (view === 'login') {
  <h2 mat-dialog-title>Log in</h2>

  <form [formGroup]="form" (ngSubmit)="submit()">
    <mat-dialog-content>
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Email</mat-label>
        <input matInput type="email" formControlName="email" autocomplete="email" required />
        @if (form.controls.email.hasError('required') && form.controls.email.touched) {
          <mat-error>Email is required.</mat-error>
        }
        @if (form.controls.email.hasError('email') && form.controls.email.touched) {
          <mat-error>Enter a valid email address.</mat-error>
        }
      </mat-form-field>

      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Password</mat-label>
        <input matInput [type]="hidePassword ? 'password' : 'text'" formControlName="password"
               autocomplete="current-password" required />
        <button mat-icon-button matSuffix type="button" (click)="hidePassword = !hidePassword"
                [attr.aria-label]="'Hide password'" [attr.aria-pressed]="hidePassword">
          <mat-icon [svgIcon]="hidePassword ? 'eye-slash' : 'eye'"></mat-icon>
        </button>
        @if (form.controls.password.hasError('required') && form.controls.password.touched) {
          <mat-error>Password is required.</mat-error>
        }
      </mat-form-field>

      <button mat-button type="button" class="forgot-password-link" (click)="showForgotPassword()">
        Passwort vergessen?
      </button>

      @if (errorMessage) {
        @if (errorIsMarkdown) {
          <div class="error-banner"><app-markdown-viewer [value]="errorMessage"></app-markdown-viewer></div>
        } @else {
          <p class="error-banner">{{ errorMessage }}</p>
        }
      }
    </mat-dialog-content>

    <mat-dialog-actions align="end">
      <button mat-button type="button" (click)="cancel()" [disabled]="submitting">Cancel</button>
      <button mat-flat-button color="primary" type="submit" [disabled]="submitting">
        @if (submitting) {
          <mat-spinner diameter="20"></mat-spinner>
        } @else {
          Log in
        }
      </button>
    </mat-dialog-actions>
  </form>
} @else if (view === 'mfaCode') {
  <h2 mat-dialog-title>Zwei-Faktor-Code</h2>

  <form [formGroup]="mfaForm" (ngSubmit)="submitMfaCode()">
    <mat-dialog-content>
      <p>Gib den 6-stelligen Code deiner Authenticator-App ein. Ohne Handy geht auch ein Recovery-Code.</p>

      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Code</mat-label>
        <input matInput formControlName="code" autocomplete="one-time-code" autocapitalize="characters" required />
      </mat-form-field>

      @if (mfaError) {
        <p class="error-banner">{{ mfaError }}</p>
      }
    </mat-dialog-content>

    <mat-dialog-actions align="end">
      <button mat-button type="button" (click)="backToLogin()" [disabled]="mfaSubmitting">Zurück</button>
      <button mat-flat-button color="primary" type="submit" [disabled]="mfaSubmitting">
        @if (mfaSubmitting) {
          <mat-spinner diameter="20"></mat-spinner>
        } @else {
          Bestätigen
        }
      </button>
    </mat-dialog-actions>
  </form>
} @else if (view === 'mfaSetup') {
  <h2 mat-dialog-title>Zwei-Faktor-Authentisierung einrichten</h2>
  <p class="mfa-setup-intro">Für deine Rolle ist die Zwei-Faktor-Authentisierung Pflicht. Richte sie jetzt ein, dann bist du angemeldet.</p>
  <app-mfa-setup [mfaToken]="mfaToken" (completed)="onMfaSetupCompleted()"
                 (cancelled)="onMfaSetupCancelled($event)"></app-mfa-setup>
} @else if (view === 'forgotPassword') {
  <h2 mat-dialog-title>Passwort vergessen</h2>

  <form [formGroup]="forgotPasswordForm" (ngSubmit)="submitForgotPassword()">
    <mat-dialog-content>
      <p>Gib deine E-Mail-Adresse ein. Falls dazu ein Konto existiert, senden wir dir einen Link zum Zurücksetzen.</p>

      <mat-form-field appearance="outline" class="full-width">
        <mat-label>E-Mail</mat-label>
        <input matInput type="email" formControlName="email" autocomplete="email" required />
        @if (forgotPasswordForm.controls.email.hasError('required') && forgotPasswordForm.controls.email.touched) {
          <mat-error>E-Mail wird benötigt.</mat-error>
        }
        @if (forgotPasswordForm.controls.email.hasError('email') && forgotPasswordForm.controls.email.touched) {
          <mat-error>Bitte eine gültige E-Mail-Adresse eingeben.</mat-error>
        }
      </mat-form-field>

      @if (forgotPasswordError) {
        <p class="error-banner">{{ forgotPasswordError }}</p>
      }
    </mat-dialog-content>

    <mat-dialog-actions align="end">
      <button mat-button type="button" (click)="backToLogin()" [disabled]="forgotPasswordSubmitting">Zurück</button>
      <button mat-flat-button color="primary" type="submit" [disabled]="forgotPasswordSubmitting">
        @if (forgotPasswordSubmitting) {
          <mat-spinner diameter="20"></mat-spinner>
        } @else {
          Link senden
        }
      </button>
    </mat-dialog-actions>
  </form>
} @else {
  <h2 mat-dialog-title>Passwort vergessen</h2>

  <mat-dialog-content>
    <p>Falls ein Konto mit dieser E-Mail existiert, haben wir dir einen Link zum Zurücksetzen des Passworts geschickt.</p>
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <button mat-flat-button color="primary" type="button" (click)="backToLogin()">Zurück zum Login</button>
  </mat-dialog-actions>
}
